/* esm.sh - rxjs@7.8.2/dist/esm/internal/util/isPromise */
import{isFunction as o}from"rxjs/dist/esm/internal/util/isFunction";function r(i){return o(i?.then)}export{r as isPromise};
//# sourceMappingURL=isPromise.mjs.map